import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User clicked "View all photos" option',
  name: 'clicked_view_all_photos_option',
  params: [
    {
      description: 'The id of the person',
      name: 'person_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Location of event',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['image-preview', 'people-tab'],
    },
  ],
};

export default META;
